var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('topInfo',{attrs:{"isUser":_vm.showUser}}),(!_vm.showUser)?_c('topEx'):_vm._e(),(!_vm.showUser)?_c('topLink'):_vm._e(),(_vm.showUser)?_c('topUser'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }